module.exports = __webpack_public_path__ + "img/vu.aacc4358.png";